import React from 'react'
import "./home.css";


// import { Slider } from "./slider";
import { Slider } from './Slider';
export const Home = () => {
  return (
    <div className="main">
            <Slider/>
    <h1>FASTRACK ESSENTIALS</h1>
    <div className="main-2">
       
       
   <div>
    <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/3156c817-5671-4edf-b846-126830b1152a/7.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-3156c817-5671-4edf-b846-126830b1152a-nU9Vu95"></img>
    <h5>GIRLS WATCHES</h5>
   </div>
   <div>
       <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/e158ebd3-893b-40c3-a139-ef745cdfc26b/4.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-e158ebd3-893b-40c3-a139-ef745cdfc26b-nU9.9Sx"></img>
       <h5>GUYS WATCHES</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/efc2dbd8-3e9d-4803-8c44-72c52b215fbc/smartwatch.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-efc2dbd8-3e9d-4803-8c44-72c52b215fbc-nWAI5r9"></img>
   <h5>SMART WATCHES</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/967e27d1-b298-4a82-9932-c9cfcf720af2/tees.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-967e27d1-b298-4a82-9932-c9cfcf720af2-nUa07AF"></img>
   <h5>TEES WATCHES</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/f2757815-3e89-4a93-8efc-f01220bcb8d3/TWE.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-f2757815-3e89-4a93-8efc-f01220bcb8d3-nZTyj7-"></img>
   <h5>EARPHONES</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/0d22aebb-e343-405b-b358-17c5bd768532/1.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-0d22aebb-e343-405b-b358-17c5bd768532-nU9VH6B"></img>
   <h5>BAGS</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/07166d76-040d-466e-b776-c30f2c87b29b/mask.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-07166d76-040d-466e-b776-c30f2c87b29b-nUa2m4g"></img>
   <h5>FACE MASKS</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/91a951ef-1105-4347-9478-36a231a678e7/essential_sunglasses2.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-91a951ef-1105-4347-9478-36a231a678e7-n3xtZUa"></img>
   <h5>PERFUMES</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/68296f46-ed24-4b8f-9150-2618a812f38f/B0398LBR02.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-68296f46-ed24-4b8f-9150-2618a812f38f-n33nXPd"></img>
   <h5>BELTS</h5>
   </div>
   <div>
   <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/c9360da4-a0a1-4bbb-b659-c55db079e3ff/essential_wallet.png?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-c9360da4-a0a1-4bbb-b659-c55db079e3ff-n33o772"></img>
   <h5>WALLETS</h5>
        </div>
        
    </div>






    <h1 className="head">TRENDING</h1>
    <div className="second-main">
        <div>
            <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/3be2ce43-768f-4a12-83c6-b1a008759b6a/1X1.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-3be2ce43-768f-4a12-83c6-b1a008759b6a-nWy3Nko">
            </img>
        </div>
        <div>
            <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/fa9b2a68-1f85-4f2a-8bcf-19202c2ea8ef/1080x1080_tunes.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-fa9b2a68-1f85-4f2a-8bcf-19202c2ea8ef-nZ1av9V">
            </img>
        </div>
        <div>
            <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/e40d8727-afa2-4175-942f-7954d778dc4b/720x720_ftbags.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-e40d8727-afa2-4175-942f-7954d778dc4b-n.ewVSY">
            </img>
        </div>
        
    </div>

    <div className="kali">

</div>





<h1>TRENDING PRODUCTS</h1>

     

        <div className="trending-cont">
         <div className="s1">
         <div className="trendingbox1">
         <div className="h1div"><h1 className="whiteh1">GET YOURSELF A WATCH THAT REFLECTS YOUR STYLE! INTRODUCING FASTRACK REFLEX VOX! NOW AVAILABLE</h1></div>
         <div> <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/abf94aff-6638-4d2b-9d93-fd5e1ab47d23/800x488.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-abf94aff-6638-4d2b-9d93-fd5e1ab47d23-nXzdHEo" alt=""
         className="trendingimg u-img"  /></div>
         </div>
         </div>
         <div className="s2">
         
         <div className="trendingbox2">
         <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/edf26fdb-502e-4253-8a74-67fe6f5e29d1/Youdoyou.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-edf26fdb-502e-4253-8a74-67fe6f5e29d1-nXzdHEo" alt=""
         className="trendingimg d-img" />
         <div>  <h1>YOU DO YOU AND COME AS YOU ARE! DIVE INTO THE WORLD OF LIMITLESS STYLE AND EXPRESSION WITH FASTRACK. </h1></div>
            </div>
           
         </div>
         </div>
              
           



        <div>
            <h1>TOP SELLERS</h1>
            <div className="top-seller">
                <div>
                <img src="https://staticimg.titan.co.in/Fastrack/Catalog/38072AP01_1.jpg?impolicy=pqmed&imwidth=320">
                </img>
                <h4>REFLEX VOX DIGITAL SILICONE BLACK STRAP WATCH</h4>
                <h5> ₹ 3995 </h5>
                </div>


                <div>
                <img src="https://staticimg.titan.co.in/Fastrack/Catalog/SWD90067PP03A_1.jpg?impolicy=pqmed&imwidth=320">
                </img>
                <h4>STUNNERS 3.0 BLACK DIAL METAL STRAP WATCH</h4>
                <h5>₹ 2595</h5>
                </div>


               <div>
               <img src="https://staticimg.titan.co.in/Fastrack/Catalog/FT3BKA01_1.jpg?impolicy=pqmed&imwidth=320">
                </img>
                <h4>STUNNERS 3.0 BLUE DIAL METAL STRAP WATCH</h4>
                <h5>₹ 2795</h5>
               </div>


                <div>
                <img src="https://staticimg.titan.co.in/Fastrack/Catalog/3254NM01_1.jpg?impolicy=pqmed&imwidth=320">
                </img>
                <h4>REFLEX 3.0 DUAL TONED SMART BAND IN MIDNIGHT BLACK & GREY ACCENT</h4>
                <h5>₹ 2095</h5>
                </div>
                
            </div>
        </div>





        <h1 className="head">FEATURED COLLECTIONS</h1>
    <div className="second-mainn">
        <div>
            <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/fa6e6aba-8cf6-47b2-aa0c-744955a1ec87/AllNighters.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-fa6e6aba-8cf6-47b2-aa0c-744955a1ec87-nvA7hNV">
            </img>
            <h2>ALL NIGHTERS</h2>
            <h5>Slay the night away and rage-in with the trendiest collection of the season for guys</h5>
        </div>
        <div>
            <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/87a1dfd7-d02c-4c30-a49c-e972ad195600/1000x1000.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-87a1dfd7-d02c-4c30-a49c-e972ad195600-n-MzHXh">
            </img>
            <h2>COLA COLA EDITION</h2>
            <h5>Introducing exclusive range of watches in the Coca-Cola Limited Edition By Fastrack</h5>
        </div>
        <div>
            <img src="https://www.fastrack.in/wps/wcm/connect/fastrack/cdf686d2-1a27-4fb0-a8fc-a39f8d4ff446/Tees+Arcade.jpg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_90IA1H80OGS700Q8OKN8NF0004-cdf686d2-1a27-4fb0-a8fc-a39f8d4ff446-np3p1lm">
            </img>
            <h2>TEES ARCADE</h2>
            <h5>Level up your game and throw it back to the 2D gaming with this sick collection.</h5>
        </div>
        
    </div>

    <div className="kali">
</div>






<h1>FOLLOW US</h1>
<div className="follow-us">
    <div div className="follow-us1">
        <div className="follow-box1">
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/93/18292566517025593/medium.jpg" className="img1"/>
        </div>
        <div className="follow-box">
        <div className="follow-box2">
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/58/17931361595308558/low_resolution.jpg" alt="" className="img2" />
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/46/18005045203414746/low_resolution.jpg" alt="" className="img2" />
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/46/17941461658954946/low_resolution.jpg" alt="" className="img2" />
        </div>
        <div className="follow-box2">
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/59/17853557054716259/low_resolution.jpg" alt="" className="img2" />
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/73/18285063595015273/low_resolution.jpg" alt="" className="img2" />
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/17/18006078325407917/low_resolution.jpg" alt="" className="img2" />

        </div>
        </div>
    </div>

    <div className="follow-us2">
    
        <div className="follow-box">
        <div className="follow-box2">
        <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/61/18135280258269461/low_resolution.jpg" alt="" className="img2" />
        <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/99/18006706471404799/low_resolution.jpg" alt="" className="img2" />
        <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/36/17939548714979436/low_resolution.jpg" alt="" className="img2" />
        </div>
        <div className="follow-box2">
        <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/69/17939140162969969/low_resolution.jpg" alt="" className="img2" />
        <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/73/18285063595015273/low_resolution.jpg" alt="" className="img2" />
        <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/46/18005045203414746/low_resolution.jpg" alt="" className="img2" />
        </div>
        </div>
        <div className="follow-box1">
            <img src="https://cdn-yotpo-images-production.yotpo.com/instagram/45/17994566383450745/medium.jpg" alt="" className="img1"/>
        </div>
        
    </div>
</div>
<button className="load-more">LOAD MORE</button>

<div className="bfooter">
    <div className="bfooter1">
        <h1>FIND YOUR NEAREST STORE</h1>
        <div>
            <button className="f-location"> Use My Current Location</button>
            <div><input type="text" placeholder="Enter a pincode or city"/> <button className="btnf"> Search</button></div>
        </div>
    </div>
    <div className="bfooter2">
        <div className="sectionsf">
            <h4>100% ORIGINAL</h4>
            <p>All our Products are Original and goes through Strick Quality check</p>
        </div>
        <div className="sectionsf">        <h4>100% ORIGINAL</h4>
            <p>All our Products are Original and goes through Strick Quality check</p></div>
        <div className="sectionsf">        <h4>100% ORIGINAL</h4>
            <p>All our Products are Original and goes through Strick Quality check</p></div>
    </div>
</div>


<div className="last-div">
    <div className="last-sub-div">
    <div className="last-heading">
        <h4>FASTRACK - ONLINE FASHION STORE</h4>
    </div>
    <div className="last-p">
        <p>We at Fastrack understand the Importance of your Fashion needs and bring up accessories that would complement your attire in every way. Fastrack is a one-stop fashion destination for you that gives you options to choose from a wide range of collectibles that covers Watches, Smartwatch, Bags, Leather Wallets, Leather Belts and much more. Our online shopping store is user-friendly and lets you find your desired fashion accessory in few clicks. With every purchase, you get encircle points that gets credited to your encircle card. You can redeem these encircle points for hefty discounts to buy fashion accessories online. Experience a seamless payment and delivery process with us. We accept payments through Credit, Debit and Net Banking.</p>
    </div>
    <div className="l-p"><h5>KNOW MORE</h5></div>
    </div>
    
</div>

</div>


    )
  
}
